export const LOCAL_STORAGE_KEY_CURRENT_ACCOUNT = 'podcast/account/current';
export const LOCAL_STORAGE_KEY_LIST = 'podcast/account/list';

export const LOCAL_STORAGE_KEY_PENDING_VERIFIER = 'podcast/auth/pending-verifier'
export const LOCAL_STORAGE_KEY_TOKEN_SETS = 'podcast/auth/token-sets'

export const LOCAL_STORAGE_KEY_PENDING_LOGIN = 'podcast/auth/pending-login';